import { Link } from "react-router-dom";
import { heroImage, site } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src={heroImage}
        alt="雾气弥漫的长廊中透出暖色灯光，象征网暴黑料当事人所处的孤立处境"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative h-full w-full flex items-center">
        <div className="w-full max-w-editorial mx-auto px-4 md:px-8">
          <div className="max-w-3xl animate-fade-rise">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-100/30 text-background-100 text-xs tracking-widest">
              <i className="ri-record-circle-line text-accent-400 animate-soft-pulse"></i>
              亲历者自述 · 伤害记录 · 心理援助
            </span>

            <h1 className="mt-6 font-heading text-3xl md:text-[54px] md:leading-[1.15] font-black text-background-50">
              {site.name}｜当「黑料」成为武器，
              <br className="hidden md:block" />
              网暴亲历者的真实处境
            </h1>

            <p className="mt-6 text-sm md:text-lg leading-relaxed text-background-100/90 max-w-2xl">
              {site.slogan}。我们记录当事人遭遇言语攻击、人肉搜索与精神创伤的完整过程，还原网暴黑料造成的伤害后果，
              也整理当事人如何一步步走出阴影的可操作路径。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <Link
                to="/stories"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              >
                阅读亲述档案
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/knowledge"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer border border-background-100/40 text-background-50 hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-heart-pulse-line"></i>
                了解如何求助与恢复
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-1 text-background-100/70">
        <span className="text-[11px] tracking-widest">向下阅读</span>
        <i className="ri-arrow-down-line text-lg animate-soft-pulse"></i>
      </div>
    </section>
  );
}